<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="配额调整审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">配额调整原因附件</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">配额调整明细</span>
        </template>
        <material-details :details-list="headInfo.maintenances" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { quotaMaintenanceCreateHead } from '@/api/quotaMaintenanceApply'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PoApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      attachList: [],
      businessKey: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const headResp = await quotaMaintenanceCreateHead(this.businessKey)
      this.headInfo = headResp.data
      this.attachList = headResp.data.files
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
